import React from 'react'
import Modal from 'react-bootstrap/Modal'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'

const WarningModal = ({ setModaltog, modaltog }) => {
    return (
        <Modal centered show={modaltog} onHide={() => setModaltog(false)} aria-labelledby="example-modal-sizes-title-sm" backdrop="static" >
            <Modal.Header className='p-1 px-2' closeButton>
                <Modal.Title className='text-danger fw-bold' id="example-modal-sizes-title-sm">Warning</Modal.Title>
            </Modal.Header>
            <Modal.Body className='p-2'>
                {/* <p className='m-0 text-center'>
                    You are receiving this warning as you didn{'\''}t start a session while entering the garage. You can still pay for the duration you stayed in by choosing the stay duration.
                </p> */}
                <p className='m-0 text-center'>
                    To avoid future violations and/or towing please pay for the duration of your stay.
                </p>
            </Modal.Body>
        </Modal>
    )
}

WarningModal.propTypes = {
    dispatch: PropTypes.func,
    warningID: PropTypes.string,
    setModaltog: PropTypes.func,
    modaltog: PropTypes.bool
}

WarningModal.defaulProps = {
    dispatch: noop,
    warningID: '',
    setModaltog: noop,
    modaltog: true,
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(WarningModal)